export default __webpack_public_path__ + "img/3b8b47afe124199b2bb887c151cd8bd3.jpg";